module.exports = __webpack_public_path__ + "static/media/north_paleomerica_icon_medium.50b1c3d4.png";